import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { formatLabel } from "../../utilities/CommonUtilities";


function DocAssistantFilterBar({
  setSelectedFilters,
  documentIds,
}) {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date());

  useEffect(() => {
    if (documentIds) {
      const seen = new Set();
      const seriesData = documentIds.reduce((acc, entry) => {
        const value = entry.impact_georegions_applicable[0];
        const label = formatLabel(value);

        if (!seen.has(value)) {
          seen.add(value);
          acc.push({ value, label });
        }
        return acc;
      }, []);

      setCountries(seriesData);
    }
  }, [documentIds]);

  const handleCountryChange = (selectedOption) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      country: selectedOption.value,
    }));
    setSelectedCountry(selectedOption);
  };


  const handleSelectedYear = (date) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      year: date.getFullYear(),
    }));
    setSelectedYear(date);
  };

  return (
    <div className="container-fluid p-3 mb-2">
      <div className="row">
        <div className="col-md-4 mb-2">
          <Select
            value={selectedCountry}
            onChange={handleCountryChange}
            options={countries}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select Country"
          />
        </div>
        <div className="col-md-1 mb-2">
          <DatePicker
            selected={selectedYear}
            onChange={(date) => handleSelectedYear(date)}
            showYearPicker
            dateFormat="yyyy"
            yearItemNumber={6}
            className="form-control"
            placeholderText="Select Year"
          />
        </div>
      </div>
    </div>
  );
}

export default DocAssistantFilterBar;
